import {useHubQuery} from '../../QueryProvider'

export const useGetNotificationSettings = () => {
  return useHubQuery('notificationSettings', [], {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
}
